let oldSource = null;

export const isNewerVersionAvailable = async () => {
  const freshSource = await fetch(window.location.origin)
    .then((res) => res.text())
    .catch((e) => {
      console.warn(`Failed to retrieve new source: ${e.message}`);
      return -1;
    });

  if (freshSource === -1 || process.env.NODE_ENV === 'development') {
    return false;
  }

  if (oldSource === null) {
    oldSource = freshSource;
    return false;
  }

  if (oldSource === freshSource) {
    return false;
  }

  oldSource = freshSource;
  return true;
};

const NEWVERSIONINTERVAL = 1000 * 60 * 10; //10 minutes

export const registerTimer = () => {
  isNewerVersionAvailable(); //load source right away

  setInterval(async () => {
    const newVersionAvailable = await isNewerVersionAvailable();

    if (!newVersionAvailable) {
      return;
    }

    const reload = window.confirm('A new update is available. Please click okay to load the latest version.');
    if (reload) {
      window.location.reload(true);
    }
  }, NEWVERSIONINTERVAL);
};
